import { Brand } from 'effect'
import { z } from 'zod'

export type RaceConfigurationRowDTO = {
  active: boolean
  created_at: string
  id: string
  laps: number
  max_pickable_marbles: number
  betting_open_seconds: number
  betting_closing_seconds: number
  settled_seconds: number
  results_to_submit: number
  name: string
  preview_thumbnail: string | null
  total_marbles: number
  track_id: string
  loss_streak_boosts: Record<string, number> | null
  win_streak_boosts: Record<string, number> | null
} & Brand.Brand<'RaceConfigurationRowDTO'>

export const RaceConfigurationRowDTORawSchema = z.object({
  active: z.boolean(),
  created_at: z.string(),
  id: z.string(),
  laps: z.number(),
  max_pickable_marbles: z.number(),
  betting_open_seconds: z.number(),
  betting_closing_seconds: z.number(),
  settled_seconds: z.number(),
  results_to_submit: z.number(),
  name: z.string(),
  preview_thumbnail: z.string().nullable(),
  total_marbles: z.number(),
  track_id: z.string(),
  loss_streak_boosts: z.record(z.string(), z.number()).nullable(),
  win_streak_boosts: z.record(z.string(), z.number()).nullable()
})

export const brandToRaceConfigurationRowDTO = Brand.nominal<RaceConfigurationRowDTO>()

export const RaceConfigurationRowDTOSchema = RaceConfigurationRowDTORawSchema.transform(
  brandToRaceConfigurationRowDTO
)
